import { DeleteOutlined, ReloadOutlined, PlusOutlined } from '@ant-design/icons';
import { Row, Space, Spin, Switch, Table, Tag, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { datLaiMatKhau, kichHoatTaiKhoan, layDSTaiKhoanTheoIdNhanVien, xoaTaiKhoan } from '../../services/nguoidung';
import { TaiKhoanResponse } from '../../models/nguoidung/NguoiDung';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { Col } from 'react-bootstrap';
import ThemTaiKhoanBox from './ThemTaiKhoanBox';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev={undefined} />;

const DanhSachTaiKhoanBox = ({ idNhanVien }: { idNhanVien: number }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isLoadingComponent, setIsLoadingComponent] = useState<boolean>(false);
    const [dsTaiKhoan, setDsTaiKhoan] = useState<Array<TaiKhoanResponse>>([]);
    const [showModalDelete, setShowModalDelete] = useState<number>(0);
    const [showModalResetPass, setShowModalResetPass] = useState<number>(0);
    const [newPass, setNewPass] = useState<string>();
    const [showThemTaiKhoan, setShowThemTaiKhoan] = useState<boolean>(false);

    const getDanhSachTaiKhoan = async (idNhanVien: number) => {
        if (!isLoadingComponent) {
            setIsLoadingComponent(true);
            const data = await layDSTaiKhoanTheoIdNhanVien(idNhanVien);
            setDsTaiKhoan(data);
            setIsLoading(false);
            setIsLoadingComponent(false);
        }
    }

    const onKichHoat = async (checked: boolean, id: number) => {
        setIsLoading(true);
        setDsTaiKhoan((prev) =>
            prev.map((item) =>
                item.id === id ? { ...item, kichHoat: checked } : item
            )
        );
        await kichHoatTaiKhoan(id, checked);
        setIsLoading(false);
    }

    const onXoaTaiKhoan = async (id: number) => {
        setIsLoading(true);
        await xoaTaiKhoan(id);
        await getDanhSachTaiKhoan(idNhanVien);
        setIsLoading(false);
    }

    const onResetPass = async (id: number) => {
        setIsLoading(true);
        const pass = await datLaiMatKhau(id);
        setNewPass(pass);
        setIsLoading(false);
    }

    useEffect(() => {
        getDanhSachTaiKhoan(idNhanVien);
    }, []);
    return (
        <>
            {
                isLoadingComponent ?
                    <Row>
                        <Space className="m-auto">
                            <Spin indicator={antIcon} />
                            Đang tải
                        </Space>
                    </Row> :
                    <>
                        <Row>
                            <Col>
                                <Button
                                    className="float-right mb-1 hrm-btn-warning"
                                    size="small"
                                    onClick={() => setShowThemTaiKhoan(true)}
                                    icon=<PlusOutlined rev="" />
                                >
                                    Thêm
                                </Button>
                            </Col>
                        </Row>
                        <Table 
                            locale={{ emptyText: "Không có dữ liệu" }}
                            bordered size="small" dataSource={(dsTaiKhoan || []).map((v) => { return { key: v.id, ...v } })} pagination={{ position: ["none", "none"] }}>
                            <Column title="Tài khoản" key="taikhoan"
                                render={(value, record, index) =>
                                (
                                    <Space>
                                        {value.tenDangNhap}
                                        {value.isAdmin ? <Tag color="red">Admin</Tag> : null}
                                    </Space>
                                )
                                }
                            />
                            <Column
                                title="Trạng thái"
                                key="trangthai"
                                render={(value, record, index) =>
                                    <Space>
                                        {value.kichHoat ? (
                                            <Tag color="green">Hoạt động</Tag>
                                        ) : (
                                            <Tag color="red">Khóa</Tag>
                                        )}
                                        <Switch defaultChecked={value.kichHoat} loading={isLoading} onChange={(checked: boolean) => onKichHoat(checked, value.id)} />
                                    </Space>
                                }
                            />
                            <Column
                                key="hanhdong"
                                render={
                                    (value, record, index) =>
                                        <Space>
                                            <Button type="primary" size={"small"} loading={isLoading} title="Đặt lại mật khẩu"
                                                icon=<ReloadOutlined rev="" />
                                                onClick={() => setShowModalResetPass(value.id)}
                                            >
                                                Reset
                                            </Button>
                                            <Button type="primary" danger size={"small"} loading={isLoading} title="Xóa"
                                                onClick={() => setShowModalDelete(value.id)}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                }
                            />
                        </Table>
                        <ThemTaiKhoanBox
                            show={showThemTaiKhoan}
                            idNhanVien={idNhanVien}
                            onClose={() => setShowThemTaiKhoan(false)}
                            onSubmit={() => {
                                getDanhSachTaiKhoan(idNhanVien);
                            }}
                        />
                        {
                            showModalDelete > 0 &&
                            <ModalTextForm show={showModalDelete > 0}
                                title="Xoá Tài khoản"
                                handleClose={() => setShowModalDelete(0)}
                                handleSave={() => {
                                    setShowModalDelete(0);
                                    onXoaTaiKhoan(showModalDelete);
                                }}>
                                Xác nhận xoá tài khoản
                            </ModalTextForm>
                        }
                        {
                            showModalResetPass > 0 &&
                            <ModalTextForm show={showModalResetPass > 0}
                                title="Reset mật khẩu tài khoản"
                                handleClose={() => setShowModalResetPass(0)}
                                handleSave={() => {
                                    setShowModalResetPass(0)
                                    onResetPass(showModalResetPass);
                                }}>
                                Xác nhận reset mật khẩu cho tài khoản
                            </ModalTextForm>
                        }
                        {
                            (newPass || "").length > 0 &&
                            <ModalTextForm show={(newPass || "").length > 0}
                                title="Mật khẩu mới"
                                handleClose={() => setNewPass("")}
                                handleSave={() => setNewPass("")}>
                                Mật khẩu mới: {newPass}
                            </ModalTextForm>
                        }
                    </>
            }
        </>
    );
};

export default DanhSachTaiKhoanBox;
